import React from 'react';
import {getNewOutlet, useOutlet} from 'reconnect.js';
import styled from 'styled-components';
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Select,
  InputNumber,
  Checkbox,
  message,
} from 'antd';
import moment from 'moment';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import * as AppActions from '../../AppActions';
const {Option} = Select;

getNewOutlet('reservation-modal', null, {autoDelete: false});

function showReservationModal(data) {
  getNewOutlet('reservation-modal').update(data);
}

function ReservationModal(props) {
  const [data] = useOutlet('reservation-modal');
  const visiable = !!data;
  const [form] = Form.useForm();

  const onCancel = () => {
    form.resetFields();
    showReservationModal(null);
  };

  const onOk = async () => {
    const fieldsValue = form.getFieldsValue();
    const _fieldsValue = Object.keys(fieldsValue).map((key, index) => ({
      name: key,
      value: Object.values(fieldsValue)[index],
    }));

    const validation = _fieldsValue.filter((field) => !field.value).length <= 0;

    if (!validation) {
      message.warning('所有欄位不可為空。');
      return;
    }

    AppActions.setLoading(true);
    try {
      let resp = await JStorage.createDocument('reservation', {
        ...fieldsValue,
        date: moment(fieldsValue['date']).valueOf(),
      });
      message.success('送出成功。');
      onCancel();
    } catch (err) {
      console.warn(err);
      message.error('送出失敗');
    }
    AppActions.setLoading(false);
  };

  return (
    <Modal
      visible={visiable}
      title="企業預約"
      width={700}
      okText="確認送出"
      cancelText="取消"
      onCancel={onCancel}
      onOk={onOk}
      maskClosable={false}>
      <Wrapper>
        <h4>
          * 目前僅<span>台北展區</span>
          提供線上預約服務，遠雄展售中心可直接以電話預約
        </h4>
        <Form form={form} style={{padding: '20px 10px 10px 10px'}} size="small">
          <Form.Item name="name" label="姓名" rules={[{required: true}]}>
            <Input />
          </Form.Item>
          <Form.Item name="phone" label="聯絡電話" rules={[{required: true}]}>
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="電子信箱"
            rules={[
              {
                required: true,
                pattern: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
                message: '請符合格式',
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            name="date"
            label="預約日期 (週日不開放參觀)"
            rules={[{required: true}]}>
            <DatePicker placeholder="選擇日期" />
          </Form.Item>
          <Form.Item name="period" label="時段" rules={[{required: true}]}>
            <Select>
              <Option value="上午10點至12點">上午10點至12點</Option>
              <Option value="下午13點至15點">下午13點至15點</Option>
              <Option value="下午15點至17點">下午15點至17點</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="position"
            label="職務類別"
            rules={[{required: true}]}>
            <Input />
          </Form.Item>
          <Form.Item
            name="company_name"
            label="公司名稱"
            rules={[{required: true}]}>
            <Input />
          </Form.Item>
          <Form.Item
            name="person_number"
            label="專案人數"
            rules={[{required: true}]}>
            <InputNumber />
          </Form.Item>
          <Form.Item
            name="industry"
            label="產業類別"
            rules={[{required: true}]}>
            <Input />
          </Form.Item>
          <Form.Item
            name="service_type"
            label="服務類別 (可複選)"
            rules={[{required: true}]}>
            <Checkbox.Group
              options={[
                {label: '系統工作站', value: '系統工作站'},
                {label: '辦公椅', value: '辦公椅'},
                {label: '單椅客椅', value: '單椅'},
                {label: '電動升降桌', value: '電動升降桌'},
                {label: '隔音設備', value: '隔音設備'},
              ]}
            />
          </Form.Item>
        </Form>
      </Wrapper>
    </Modal>
  );
}

const Wrapper = styled.div`
  & > h4 {
    text-align: center;
  }

  & > h4 > span {
    padding: 0px 5px;
    color: red;
  }
`;

export {showReservationModal};
export default ReservationModal;
